import { render, staticRenderFns } from "./SeniorLifeMembershipList.vue?vue&type=template&id=148b64f5"
import script from "./SeniorLifeMembershipList.vue?vue&type=script&lang=js"
export * from "./SeniorLifeMembershipList.vue?vue&type=script&lang=js"
import style0 from "./SeniorLifeMembershipList.vue?vue&type=style&index=0&id=148b64f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports